export default __webpack_public_path__ + "static/media/PO0131005_WF_BRAND_2HFY24_ISF_DecUpdate17_LP_767x577.73a76baf.jpg";